var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
const API_BASE_URL = window._env_.REACT_APP_SIGNO_API_URL;
const clientId = window._env_.REACT_APP_CLIENT_ID;
const clientSecret = window._env_.REACT_APP_CLIENT_SECRET;
export class AuthRepository {
    getClientToken(clientIdAux, clientSecretAux) {
        return __awaiter(this, void 0, void 0, function* () {
            const finalClientId = clientIdAux !== null && clientIdAux !== void 0 ? clientIdAux : clientId;
            const finalClientSecret = clientSecretAux !== null && clientSecretAux !== void 0 ? clientSecretAux : clientSecret;
            const response = yield axios.post(`${API_BASE_URL}/Auth/Client`, { clientId: finalClientId, clientSecret: finalClientSecret });
            return response.data;
        });
    }
    login(username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios.post(`${API_BASE_URL}/User/login`, { username, password });
            return response.data;
        });
    }
    refreshToken(refreshToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios.post(`${API_BASE_URL}/Auth/RefreshToken`, { refreshToken });
            return response.data;
        });
    }
}
